import { render, staticRenderFns } from "./FacDetalhe.vue?vue&type=template&id=557fc39c&"
import script from "./FacDetalhe.vue?vue&type=script&lang=js&"
export * from "./FacDetalhe.vue?vue&type=script&lang=js&"
import style0 from "./FacDetalhe.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports